module.exports = __webpack_public_path__ + "static/media/share_black.7d0e5402.svg";